import { OrganizationType, UserRole } from "../../__generated__/graphql";

export enum FEATURES {
  SHARING_INVITATION,
  CREATE_DOCUMENT,
  CREATE_INTEGRATION,
  INVITE_MEMBER,
  DELETE_MEMBER,
}

type FeatureFlags = {
  [K in FEATURES]: boolean;
};

type OrganizationFeatures = {
  [K in UserRole]: FeatureFlags;
};

const ARTIST_ORGANIZATION_FEATURES: OrganizationFeatures = {
  [UserRole.AccountHolder]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: false,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Admin]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: true,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Member]: {
    [FEATURES.SHARING_INVITATION]: false,
    [FEATURES.CREATE_DOCUMENT]: false,
    [FEATURES.CREATE_INTEGRATION]: false,
    [FEATURES.INVITE_MEMBER]: false,
    [FEATURES.DELETE_MEMBER]: false,
  },
};

const PRODUCER_ORGANIZATION_FEATURES: OrganizationFeatures = {
  [UserRole.AccountHolder]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: true,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Admin]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: true,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Member]: {
    [FEATURES.SHARING_INVITATION]: false,
    [FEATURES.CREATE_DOCUMENT]: false,
    [FEATURES.CREATE_INTEGRATION]: false,
    [FEATURES.INVITE_MEMBER]: false,
    [FEATURES.DELETE_MEMBER]: false,
  },
};

const AGENCY_ORGANIZATION_FEATURES: OrganizationFeatures = {
  [UserRole.AccountHolder]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: false,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Admin]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: true,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Member]: {
    [FEATURES.SHARING_INVITATION]: false,
    [FEATURES.CREATE_DOCUMENT]: false,
    [FEATURES.CREATE_INTEGRATION]: false,
    [FEATURES.INVITE_MEMBER]: false,
    [FEATURES.DELETE_MEMBER]: false,
  },
};

const OTHER_ORGANIZATION_FEATURES: OrganizationFeatures = {
  [UserRole.AccountHolder]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: true,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Admin]: {
    [FEATURES.SHARING_INVITATION]: true,
    [FEATURES.CREATE_DOCUMENT]: true,
    [FEATURES.CREATE_INTEGRATION]: true,
    [FEATURES.INVITE_MEMBER]: true,
    [FEATURES.DELETE_MEMBER]: true,
  },
  [UserRole.Member]: {
    [FEATURES.SHARING_INVITATION]: false,
    [FEATURES.CREATE_DOCUMENT]: false,
    [FEATURES.CREATE_INTEGRATION]: false,
    [FEATURES.INVITE_MEMBER]: false,
    [FEATURES.DELETE_MEMBER]: false,
  },
};

export const PERMISSIONS: Record<OrganizationType, OrganizationFeatures> = {
  [OrganizationType.Artist]: ARTIST_ORGANIZATION_FEATURES,
  [OrganizationType.Producer]: PRODUCER_ORGANIZATION_FEATURES,
  [OrganizationType.Agency]: AGENCY_ORGANIZATION_FEATURES,
  [OrganizationType.Other]: OTHER_ORGANIZATION_FEATURES,
};
